import React, { Component } from 'react'
import WechatShareScreen from './components/index'

class WechatShare extends Component {
  render() {
    return (
      <div>
        <WechatShareScreen {...this.props} />
      </div>
    )
  }
}

export default WechatShare



// WEBPACK FOOTER //
// ./src/modules/wechatShare/index.js